import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { DashboardsLandingPageIcon } from './dashboards-landing-page';
import { dashboardsRootRouteRef } from '../../routes';

export const dashboardsLandingPage = PageBlueprint.make({
  params: {
    title: 'Dashboards',
    path: '/dashboards',
    icon: DashboardsLandingPageIcon,
    routeRef: dashboardsRootRouteRef,
    loader: () =>
      import('./dashboards-landing-page').then(m => (
        <m.DashboardsLandingPage />
      )),
  },
});

export const dashboardsLandingPagePlugin = createFrontendPlugin({
  pluginId: 'dashboards-landing-page',
  extensions: [dashboardsLandingPage],
});
